// M5TextAndImageFeature.tsx
import { M5TextAndImage } from 'ui/components/3-organisms/M5TextAndImage/M5TextAndImage';

export const M5TextAndImageFeature: React.FC<Umbraco.M5TextAndImage> = ({ content }) => {
	const { variant, title, subtitle, text, link1, link2, link3, image, anchor } = content?.properties ?? {};

	return (
		<M5TextAndImage
			variant={variant}
			title={title}
			subtitle={subtitle}
			text={text}
			link1={link1}
			link2={link2}
			link3={link3}
			image={image}
			anchor={anchor}
		/>
	);
};
